class SalaDisputa {
  loading_opened = false;

  constructor(objParent) {
    this.objParent = objParent;
    this.lote_em_pregao_control = 0;
    this.db = objParent.firebase_db;
    this.lotesData = {};
    this.loteDataCount = 0;
  }

  acampanharLancesTelao(leilao_id, lote_id) {
    const self = this;

    self.db.ref(`/lance/${leilao_id}/${lote_id}`)
      .orderByChild("id")
      .once("value")
      .then((dados) => {
        self.objParent.$emit('lances', dados.val());
        self.objParent.lances = dados.val();
      })
  }

  /* atualiza lotes */
  async refreshLotesListagem(is_seguiremleilao = false) {
    const thisP = this.objParent;
    const self = thisP;
    const thisObj = this;
    let start = 1;

    const handleLotesData = (data, callback = null) => {
      let lotes = Object.values(data.val() || {});

      if (thisP.paginaAtual > 1) {
        start = (thisP.paginaAtual - 1) * thisP.numeroRegistrosPorPagina + 1;
      }

      self.lotes = lotes
        .sort((a, b) => a.seq - b.seq)
        .slice(start - 1, start - 1 + thisP.numeroRegistrosPorPagina)
        .map(lote => thisObj.vistoriaCampos(lote));

      if (callback)
        callback();
    };

    const configureLotes = () => {
      thisObj.observaLotesStatusLance(self.lotes);
      thisObj.configuraFavoritos();
      thisObj.configuraVisitas();
      self.actionSeguir();
      //thisP.stopLoading();
    };

    if (!is_seguiremleilao) {
      thisP.ordernar_por = 'seq';

      if (thisObj.refreshLotesDb) {
        thisObj.refreshLotesDb.off();
        thisObj.refreshLotesDb = null;
      }

      const currentPageIndex = Math.max(thisP.paginaAtual - 1, 0);
      const lotesToObserve = thisP.lotesAcompanhar.length > 0 ? thisP.lotesAcompanhar[currentPageIndex] : [];
      const lotesRef = thisObj.db.ref(`/lote/${thisP.leilaoId}`);

      // Busca a lista geral dos lotes ordenados
      await lotesRef.orderByChild(thisP.ordernar_por).once('value')
        .then(snapshot => {
          if (!snapshot.exists()) {
            return Promise.reject("Nenhum lote encontrado."); // Interrompe a execução
          }
          // Processa os dados da lista geral
          return new Promise(resolve => {
            handleLotesData(snapshot);
            resolve(); // Garante que continue após processar os dados
          });
        })
        .then(() => {
          // Agora busca os lotes observados
          return Promise.all(
            lotesToObserve.map(loteId => lotesRef.child(loteId).once('value'))
          );
        })
        .then(lotes => {
          if (thisP.leilao.leilao_id_primeiroleilao) {
            handleLinkedLeiloes(lotes, configureLotes);
          } else {
            configureLotes();
          }
        })
        .catch(error => console.error("Erro ao buscar lotes:", error));

    } else {
      thisP.ordernar_por = 'seq_dtfechamento';

      thisObj.refreshLotesDb = thisObj.db.ref(`/lote/${thisP.leilaoId}`)
        .orderByChild(thisP.ordernar_por)
        .equalTo(true);

      thisObj.refreshLotesDb.on('value', snapshot => {
        if (!snapshot.exists()) {
          self.lotes = null;
          return;
        }

        const lotesData = Object.values(snapshot.val() || {}).map(lote => thisObj.vistoriaCampos(lote));

        if (lotesData.length === 0) {
          self.lotes = null;
          return;
        }

        self.naoEncomtrado = false;
        self.lotes = lotesData;

        if (thisP.leilao.leilao_id_primeiroleilao) {
          handleLinkedLeiloes(self.lotes, configureLotes);
        } else {
          configureLotes();
        }
      }, error => console.error("Erro ao buscar lotes com seq_dtfechamento:", error));
    }

    async function handleLinkedLeiloes(lotes, callback = null) {
      const lotesAtual = lotes.map(lote => thisObj.vistoriaCampos(lote.val()));

      await thisObj.db.ref(`/lote/${thisP.leilao.leilao_id_primeiroleilao}`).once('value').then(data => {
        const lotesPrimeiroLeilao = Object.values(data.val() || {});

        const lotesVinculados = lotesAtual.map(loteAtual => {
          const matchingLote = lotesPrimeiroLeilao.find(lotePrimeiro =>
            thisObj.vistoriaCampos(lotePrimeiro).vistoria_id === loteAtual.vistoria_id
          );

          if (matchingLote) {
            loteAtual.primeiro_vistoria_vl_lanceinicial = matchingLote.vistoria_vl_lanceinicial;
          }

          return loteAtual;
        }).filter(Boolean);

        self.lotes = lotesVinculados;

        if (!lotesVinculados.length) {
          self.naoEncomtrado = true;
          return;
        }

        self.naoEncomtrado = false;
        if (callback)
          callback();
      });
    }
  }

  ordenaLotesPorSeq(lotes) {
    lotes.sort(function (a, b) {
      return a.seq - b.seq;
    });
  }

  carregaLoteEmPregao(lote_id_pregao, leilao_id) {
    const thisObj = this.objParent;
    const self = this;

    if (thisObj.leilao.leilao_id_primeiroleilao) {
      self.db.ref(`/lote/${leilao_id}/${lote_id_pregao}`)
        .once("value")
        .then(function (data) {

          if (data.val() == null) {
            thisObj.lote_em_pregao = data.val();
            thisObj.lote_em_pregao = self.vistoriaCampos(thisObj.lote_em_pregao);
            self.observaLotePregao(leilao_id, lote_id_pregao);
            return
          }

          const lotes_segundo_leilao = [];
          lotes_segundo_leilao.push(self.vistoriaCampos(data.val()));

          self.db.ref(`/lote/${thisObj.leilao.leilao_id_primeiroleilao}`).once("value", function (data) {
            const lotes_primeiro_leilao = data.val();
            const lote_segundo_leilao = Object.keys(lotes_segundo_leilao).map((key) => {
              const vistoria_id_segundo_leilao = lotes_segundo_leilao[key].vistoria_id;

              // Lotes do primeiro leilao
              const lote_primeiro_leilao = Object.keys(lotes_primeiro_leilao).map((keyPrimeiro) => {
                const lotePerimeiro = self.vistoriaCampos(lotes_primeiro_leilao[keyPrimeiro]);
                const vistoria_id_primeiro_leilao = lotePerimeiro.vistoria_id;
                return (vistoria_id_primeiro_leilao == vistoria_id_segundo_leilao)
                  ? lotePerimeiro : false;
              }).filter((lote) => lote);

              // Pegando dados do primeiro leilao
              lotes_segundo_leilao[key].primeiro_vistoria_vl_lanceinicial = lote_primeiro_leilao[0].vistoria_vl_lanceinicial;
              return (lote_primeiro_leilao.length == 1) ? lotes_segundo_leilao[key] : false;
            }).filter((lote) => lote);

            thisObj.lote_em_pregao = lote_segundo_leilao[0];
            self.observaLotePregao(leilao_id, lote_id_pregao);
          })
        })
    } else {
      self.db.ref(`/lote/${leilao_id}/${lote_id_pregao}`)
        .once("value")
        .then(function (data) {
          thisObj.lote_em_pregao = data.val();
          thisObj.lote_em_pregao = self.vistoriaCampos(thisObj.lote_em_pregao);
          self.observaLotePregao(leilao_id, lote_id_pregao);
        })
    }
  }

  vistoriaCampos(lote) {
    if (lote && lote.vistoria) {
      const self = this;

      lote.vistoria.forEach((vistoria) => {
        lote.vistoria_vl_lanceinicial = 'R$ ' + self.formatPrice(vistoria.vl_lanceinicial);
        lote.vistoria_vl_lanceinicialsegundoleilao = 'R$ ' + self.formatPrice(vistoria.vl_lanceinicialsegundoleilao);
        // Definir vistoria_id com base no primeiro identificador disponível
        lote.vistoria_id = vistoria.imovel_id || vistoria.veiculo_id || vistoria.equipamento_id || null;
      });
    }

    return lote;
  }


  formatPrice(price) {
    return parseFloat(price)
      .toFixed(2).replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  limpaLotePregaoReference() {
    if (this.objParent.loteStatusReference != null) {
      this.objParent.loteStatusReference.off();
      this.objParent.loteLanceReference.off();
      this.objParent.loteIncrementoReference.off();
      this.objParent.loteDtfechamentoReference.off();

      this.objParent.loteStatusReference = null;
      this.objParent.loteLanceReference = null;
      this.objParent.loteIncrementoReference = null;
      this.objParent.loteDtfechamentoReference = null;
    }
  }

  observaLotePregao(leilao_id, lote_id_pregao) {
    const thisObj = this.objParent;
    const self = this;

    thisObj.loteStatusReference = self.db.ref(
      `/status/${leilao_id}/${lote_id_pregao}`
    );
    thisObj.loteLanceReference = self.db.ref(
      `/lance/${leilao_id}/${lote_id_pregao}`
    );
    thisObj.loteIncrementoReference = self.db.ref(
      `/incremento/${leilao_id}/${lote_id_pregao}`
    );
    thisObj.loteDtfechamentoReference = self.db.ref(
      `/dtfechamento/${leilao_id}/${lote_id_pregao}`
    );

    /* status */
    thisObj.loteStatusReference.on("value", function (loteData) {
      if (loteData.val()) {
        const data = loteData.val();
        if (data.lote_id == thisObj.lote_id_pregao) {
          thisObj.lote_em_pregao.liberado = false;

          thisObj.lote_em_pregao.statuslote = data.statuslote;
          thisObj.lote_em_pregao.statusLoteBg = data.statusLoteBg;
          thisObj.lote_em_pregao.liberado = true;

          if (data.statuslote_id == 15 || data.statuslote_id == 13 || data.statuslote_id == 10) {
            //Status Cancelado e Retirado, nao permitir enviar lance
            thisObj.lote_em_pregao.liberado = false;
          }

          if (data.statusliberacaolote_id != undefined) {
            if (data.statusliberacaolote_id != 2) {
              //Status Liberação (status de dentro do loteamento) só permitir lance se estiver como liberado
              thisObj.lote_em_pregao.liberado = false;
            }
          }
        }
      }
    });

    /* incremento */
    thisObj.loteIncrementoReference.on("value", function (loteData) {
      if (loteData.val()) {
        const data = loteData.val();
        thisObj.lote_em_pregao.raw_incremento = data.raw_incremento;

        let lance = thisObj.lote_em_pregao.vl_lance
          .replace(/\./g, "")
          .replace("R$ ", "")
          .replace(",", ".");

        lance = parseFloat(lance);
        if (lance <= 0) {
          let lancesugerido = parseFloat(
            thisObj.lote_em_pregao.vl_lanceinicial
          );
          if (lancesugerido <= 0) {
            lancesugerido = parseFloat(thisObj.lote_em_pregao.raw_incremento);
          }
          thisObj.lote_em_pregao.vl_lance_sugerido = thisObj.$root.formatarPreco(
            lancesugerido
          );
        } else {
          thisObj.lote_em_pregao.vl_lance_sugerido = thisObj.$root.formatarPreco(
            parseFloat(lance) +
            parseFloat(thisObj.lote_em_pregao.raw_incremento)
          );
        }
      }
    });

    /* lance */
    thisObj.loteLanceReference.on("value", function (snapshot) {
      const data = snapshot.val();

      // Atualiza a quantidade de lances
      if (data) {
        const countLances = Object.keys(data).length;
        thisObj.lote_em_pregao.count_lances = countLances;

        // Verifica se houve algum lance adicionado ou removido
        const lastLance = Object.keys(data).length > 0 ? Object.values(data).pop() : null;

        if (lastLance) {
          self.atualizaLanceLotePregao(lastLance);
        }

        // Caso não exista mais nenhum lance
        if (countLances === 0) {
          const params = {
            nm_apelido: null,
            vl: 0.0,
            lote_id: null // Você pode pegar o lote_id de algum lugar aqui
          };
          self.atualizaLanceLotePregao(params);
        }
      }
    });

    // thisObj.loteLanceReference.on("value", function (lancesData) {
    //   const data = lancesData.val();
    //
    //   if (lancesData.val()) {
    //     const countLances = data ? Object.keys(data).length : 0;
    //     thisObj.lote_em_pregao.count_lances = countLances;
    //   }
    // });
    //
    // thisObj.loteLanceReference
    //   .orderByChild("id")
    //   .limitToLast(1)
    //   .on("child_added", function (lanceData) {
    //     if (lanceData.val()) {
    //       self.atualizaLanceLotePregao(lanceData.val());
    //     }
    //   });
    //
    // thisObj.loteLanceReference.on("child_removed", function (dataRemoved) {
    //   thisObj.loteLanceReference.on("value", function (snapshot) {
    //     if (!snapshot.exists()) {
    //       const params = {
    //         nm_apelido: null,
    //         vl: 0.0,
    //         lote_id: dataRemoved.val().lote_id
    //       };
    //       self.atualizaLanceLotePregao(params);
    //     }
    //   });
    // });

    /* Dt fechamento */
    thisObj.loteDtfechamentoReference.on("value", function (loteData) {
      if (loteData.val()) {
        const data = loteData.val();
        thisObj.lote_em_pregao.dt_fechamento = data.dt_fechamento;
      } else {
        const today = new Date();
        const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        if (!thisObj.lote_em_pregao) {
          return
        }
        thisObj.lote_em_pregao.dt_fechamento = date + ' ' + time;
      }
    });
  }

  /* limpa references */
  limpaLotesReference() {
    [
      this.objParent.lotesStatusReference,
      this.objParent.lotesLanceReference,
      this.objParent.lotesIncrementoReference,
      this.objParent.lotesDtfechamentoReference
    ].forEach((arr) => {
      arr.forEach((ref) => {
        ref.off();
      });
      arr = [];
    });
  }

  /* observa status e ultimo lance dos lotes */
  async observaLotesStatusLance(lotes) {
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    // clear all
    this.limpaLotesReference();
    const thisP = this.objParent;
    const self = this;
    this.lotesData = {};

    for (const key in lotes) {
      const _lote = lotes[key];

      if (this.lotesData.hasOwnProperty(_lote.lote_id) == false) {
        this.lotesData[_lote.lote_id] = _lote;
        let loteRef = self.db.ref(`/lance/${_lote.leilao_id}/${_lote.lote_id}`);

        thisP.lotesStatusReference.push(
          self.db.ref(`/status/${_lote.leilao_id}/${_lote.lote_id}`)
        );
        thisP.lotesIncrementoReference.push(
          self.db.ref(`/incremento/${_lote.leilao_id}/${_lote.lote_id}`)
        );
        thisP.lotesDtfechamentoReference.push(
          self.db.ref(`/dtfechamento/${_lote.leilao_id}/${_lote.lote_id}`)
        );
        thisP.lotesLanceReference.push(loteRef);

        loteRef.once("value").then((lancesData) => {
          const data = lancesData.val();
          const countLances = data ? Object.keys(data).length : 0;
          const loteId = _lote.lote_id;

          const params = {
            count_lances: countLances,
            lote_id: loteId
          };

          self.atualizaCountLances(lotes, params);
        });
      }
    }

    /* status */
    thisP.lotesStatusReference.forEach(function (ref) {
      ref.on("value", (loteData) => {
        const data = loteData.val();
        const idx = lotes.findIndex(i => i.lote_id == data.lote_id);

        if (idx !== -1) {
          lotes[idx].statuslote = data.statuslote;
          lotes[idx].statusLoteBg = data.statusLoteBg;
          lotes[idx].liberado = true;

          if (data.statuslote_id == 15 || data.statuslote_id == 13 || data.statuslote_id == 10) {
            lotes[idx].liberado = false;
          }

          if (data.statusliberacaolote_id != undefined) {
            if (data.statusliberacaolote_id != 2) {
              lotes[idx].liberado = false;
            }
          }
        }
      });
    });

    /* incremento */
    thisP.lotesIncrementoReference.forEach(function (ref) {
      ref.on("value", function (loteData) {
        const data = loteData.val();
        const idx = lotes.findIndex(i => i.lote_id == data.lote_id);

        if (idx !== -1) {
          lotes[idx].raw_incremento = data.raw_incremento;

          let lance = lotes[idx].vl_lance
            .replace(/\./g, "")
            .replace("R$ ", "")
            .replace(",", ".");

          lance = parseFloat(lance);
          if (lance <= 0) {
            let lancesugerido = parseFloat(lotes[idx].vl_lanceinicial);
            if (lancesugerido <= 0) {
              lancesugerido = parseFloat(lotes[idx].raw_incremento);
            }
            lotes[idx].vl_lance_sugerido = thisP.$root.formatarPreco(lancesugerido);
          } else {
            lotes[idx].vl_lance_sugerido = thisP.$root.formatarPreco(
              parseFloat(lance) + parseFloat(lotes[idx].raw_incremento)
            );
          }
        }
      });
    });

    /* lance */
    thisP.lotesLanceReference.forEach(function (ref) {
      ref
        .orderByChild("id")
        .limitToLast(1)
        .on("child_added", function (lanceData) {
          self.atualizaLance(lotes, lanceData.val());
        });
    });

    thisP.lotesLanceReference.forEach(function (ref) {
      ref.on("child_removed", function (dataRemoved) {
        ref.on("value", function (snapshot) {
          if (!snapshot.exists()) {
            const params = {
              nm_apelido: null,
              vl: 0.0,
              lote_id: dataRemoved.val().lote_id
            };
            self.atualizaLance(ref, params);
          }
        });
      });
    });

    /* dt fechamento */
    thisP.lotesDtfechamentoReference.forEach(function (ref) {
      ref.on("value", function (loteData) {
        if (loteData.val()) {
          const data = loteData.val();
          const idx = lotes.findIndex(i => i.lote_id == data.lote_id);
          if (idx !== -1 && typeof lotes[idx] === 'object') {
            lotes[idx].dt_fechamento = data.dt_fechamento;
          }
        } else {
          const today = new Date();
          const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          if (thisP.lote_em_pregao && typeof thisP.lote_em_pregao === 'object') {
            thisP.lote_em_pregao.dt_fechamento = date + ' ' + time;
          }
        }
      });
    });

    // Total lances
    thisP.lotesLanceReference.forEach((ref) => {
      ref.orderByChild('id').on('value', function (lancesData) {
        const data = lancesData.val();
        const countLances = data ? Object.keys(data).length : 0;
        const loteId = ref.key;

        const params = {
          count_lances: countLances,
          lote_id: loteId
        };

        self.atualizaCountLances(lotes, params);
      });
    });
  }

  atualizaLance(lotes, data) {
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    const thisP = this.objParent;
    const idx = lotes.findIndex(i => i.lote_id === data.lote_id);

    if (idx !== -1) {
      // Verifica se encontrou o lote com o lote_id correspondente
      lotes[idx].nm_usuario = data.nm_apelido;
      lotes[idx].vl_lance = thisP.$root.formatarPreco(data.vl);

      const l = parseFloat(data.vl);

      if (l <= 0) {
        let lancesugerido = parseFloat(lotes[idx].vl_lanceinicial);
        if (lancesugerido <= 0) {
          lancesugerido = parseFloat(lotes[idx].raw_incremento);
        }
        lotes[idx].vl_lance_sugerido = thisP.$root.formatarPreco(lancesugerido);
      } else {
        lotes[idx].vl_lance_sugerido = thisP.$root.formatarPreco(
          l + parseFloat(lotes[idx].raw_incremento)
        );
      }
    }
  }

  atualizaCountLances(lotes, data) {
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    const idx = lotes.findIndex(i => i.lote_id == data.lote_id);

    if (idx !== -1) {
      lotes[idx].count_lances = data.count_lances;
    }
  }

  atualizaLanceLotePregao(data) {
    const thisP = this.objParent;

    thisP.lote_em_pregao.nm_usuario = data.nm_apelido;
    thisP.lote_em_pregao.vl_lance = thisP.$root.formatarPreco(data.vl);

    const l = parseFloat(data.vl);

    if (l <= 0) {
      let lancesugerido = parseFloat(thisP.lote_em_pregao.vl_lanceinicial);

      if (lancesugerido <= 0) {
        lancesugerido = parseFloat(thisP.lote_em_pregao.raw_incremento);
      }

      thisP.lote_em_pregao.vl_lance_sugerido = thisP.$root.formatarPreco(
        lancesugerido
      );
    } else {
      thisP.lote_em_pregao.vl_lance_sugerido = thisP.$root.formatarPreco(
        l + parseFloat(thisP.lote_em_pregao.raw_incremento)
      );
    }
  }

  calculaQtdePaginas() {
    const thisP = this.objParent;

    if (thisP.lotesAcompanhar.length > 0) {
      thisP.paginator.pageCount = thisP.lotesAcompanhar.length;
      return;
    }

    const self = thisP;

    this.db.ref(`/lote/${thisP.leilaoId}`)
      .once("value")
      .then(function (data) {
        if (data.exists()) {
          const lotesLeialo = Object.values(data.val());

          self.paginator.countLote = Object.keys(lotesLeialo).length;

          let qtdePaginas = parseInt(self.paginator.countLote / self.numeroRegistrosPorPagina);
          if (self.paginator.countLote % self.numeroRegistrosPorPagina > 0) {
            qtdePaginas++;
          }
          self.paginator.pageCount = qtdePaginas;

        } else {
          self.paginator.countLote = 0;
          self.paginator.pageCount = 0;
        }
      })
  }

  tipoParcelamento(leilao_id, lote_id) {
    const thisP = this.objParent;

    this.db
      .ref(`/lote/${leilao_id}/${lote_id}/bn_aceitelanceparceladolote`)
      .on("value", (snapshot) => {
        thisP.tipoParcelamento = snapshot.val();
      }, (error) => {
        console.error("Erro no monitoramento em tempo real:", error);
      });
  }


  async registraLotePregao() {
    const thisP = this.objParent;
    const self = thisP;

    await this.db.ref(`/leilao/${thisP.leilaoId}`).once("value").then(function (data) {
      self.leilao = data.val();
    });

    this.db.ref(`/geral/${thisP.leilaoId}/lote_id_pregao`).on("value", function (ret) {
      self.lote_id_pregao = ret.val();
      self.actionSeguir();
    });
  }

  determinaLotesAcompanhar(l) {
    const thisP = this.objParent;
    const lacompanhar = [];
    while (l.length > 0) {
      lacompanhar.push(l.splice(0, thisP.numeroRegistrosPorPagina));
    }
    thisP.lotesAcompanhar = lacompanhar;
  }

  filtrarAction() {
    const thisP = this.objParent;
    const hostName = location.protocol + "//" + window.HOSTNAME;

    thisP.$vs.loading({
      background: "#fff",
      color: "#67302B"
    });

    fetch(`${hostName}/leilao/filtro-id/leilao_id/${thisP.leilaoId}?${thisP.parametrosFiltro}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then(response => {
        if (response.length <= 0) {
          thisP.naoEncomtrado = true;
          thisP.loadingPage = false;
          thisP.$vs.loading.close();
          return false;
        }

        if (response.status == "nao_filtrar") {
          // sem filtros
          thisP.lotesAcompanhar = [];
          thisP.paginaAtual = 1;
          this.calculaQtdePaginas();
          this.refreshLotesListagem();
          thisP.$vs.loading.close();
          return;
        }

        thisP.filtros = response.filtros;

        const l = response.lotes.map(function (ll) {
          return ll.lote_id;
        });
        this.determinaLotesAcompanhar(l);
        this.calculaQtdePaginas();

        // voltar para primeira pagina apos o filtro
        this.refreshLotesListagem();
        thisP.$vs.loading.close();
      });
  }

  configuraFavoritos(_self) {
    const thisP = this.objParent;
    thisP.lotes.forEach(function (lote) {
      if (
        thisP.usuario &&
        thisP.usuario.interesse &&
        thisP.usuario.interesse.indexOf(lote.lote_id) >= 0
      ) {
        lote.is_favorito = true;
      } else {
        lote.is_favorito = false;
      }
    });

    if (_self) {
      _self.$forceUpdate();
    }
  }

  configuraVisitas() {
    const thisP = this.objParent;
    const lotes = thisP.lotes;
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    thisP.visitas.forEach(v => {
      const idx = lotes.findIndex(l => l.lote_id == v.lote_id);
      if (idx > -1) {
        thisP.lotes[idx].nu_visitas = v.nu_visitas;
        thisP.lotes[idx].rating = v.rating;
      }
    });
  }

  /* lotes agrupados -> Busca e Categoria */
  refreshLotesAgrupados(lotes) {
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    const thisP = this.objParent;
    const self = this;

    thisP.lotesAgrupados.map((item, i) => {
      item.lotes.forEach(function (l) {
        const idx = lotes.findIndex(x => x.lote_id == l.lote_id);

        l.statuslote = lotes[idx].statuslote;
        l.statusLoteBg = lotes[idx].statusLoteBg;
        l.vl_lance = lotes[idx].vl_lance;
        l.vl_lance_sugerido = lotes[idx].vl_lance_sugerido;
      });
    });
  }

  notificationLeilao(leilao) {
    if (leilao.id == 23287 || leilao.leilao_id_primeiroleilao == 23287) {
      return true;
    }
    return false;
  }
}

window
  .saladisputa = SalaDisputa;



// WEBPACK FOOTER //
// ./src/assets/js/saladisputa.js